import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http"
import { Observable } from "rxjs";
import { API_URL } from "./env";

/**
 * Service class for interacting with config keys from the onco.Config database table. This is different
 * than the config.service.ts class, which is more used for storing config settings at a device level
 * (such as language, contrast, etc...). These key-value pairs represent values which may change and should be able
 * to be modified easily simply by updating the value in the database such as URLs or file paths.
 */
@Injectable()
export class DbConfigService {

    constructor(private http: HttpClient) { }

    /**
     * Used to retrieve the value of a key-value pair from the onco.Config table.
     * @param {string} key - The key of the key-value pair. In the database this is the 'name' column.
     * @returns {string} The value of the key-value pair. In the database this is the 'value' column.
     * @example
     * // If the key-value pair is Key: FavoriteColor and Value: Green
     *
     * getValue("FavoriteColor")
     *
     * // Returns "Green"
     */
    getValue(key: string): Observable<any> {
        return this.http.get(API_URL + "/config/get_value", {
            params: new HttpParams().set('configKey', key),
            withCredentials: true,
            observe: 'response'
        });
    }
}